/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does a longer term mean more interest?`)
};

const es_ln_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué un plazo más largo significa más interés?`)
};

const de_ln_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum bedeutet eine längere Laufzeit mehr Zinsen?`)
};

const nl_ln_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom betekent een langere looptijd meer rente?`)
};

const fr_ln_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi une durée plus longue signifie-t-elle plus d'intérêt?`)
};

const it_ln_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché un termine più lungo significa più interesse?`)
};

const pt_br2_ln_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que um prazo mais longo significa mais juros?`)
};

const pt_ln_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que é que um prazo mais longo significa mais juros?`)
};

const ja_ln_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「なぜ長期間はより多くの利息を意味するのですか？」`)
};

const zh_ln_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么期限越长，利息越多？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_faq4_q", locale)
	if (locale === "en") return en_ln_faq4_q(inputs)
	if (locale === "es") return es_ln_faq4_q(inputs)
	if (locale === "de") return de_ln_faq4_q(inputs)
	if (locale === "nl") return nl_ln_faq4_q(inputs)
	if (locale === "fr") return fr_ln_faq4_q(inputs)
	if (locale === "it") return it_ln_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_ln_faq4_q(inputs)
	if (locale === "pt") return pt_ln_faq4_q(inputs)
	if (locale === "ja") return ja_ln_faq4_q(inputs)
	return zh_ln_faq4_q(inputs)
};